import { NgModule, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SocketService } from '../../services/socket.service';
import { SharedPipeChatModule } from '../../shared/shared.pipe.chat.module';
import { UserInfoModule } from '../../components/userInfo';
import { TransferSnsTimePipeModule } from '../../pipes/transferSnsTime.pipe';
import { EventService } from '../../services/event.service';

@Component({
    selector: 'chat-room-list',
    template: `
        <!-- chat_box -->
        <div class="chat_box">
            <div  #scrollMe class="chat_room_list scroll" [ngStyle]="{height: (dynamicHeight) + 'px'}" >
                <ul>
                    <li *ngFor="let list of roomList" (click)="goto_chatRoom_view(list.roomid)">
                        <dl>
                            <dt><a>[{{list.gametypetxt}}] {{list.roomname}}</a></dt>
                            <dd class="room_img">
                                <user-info [mbid]="list.creater.mb_id">
                                    <img [src]="'//www.chanceball.com/data/chat/' + list.roomid"  alt="" class="profileImgS4" err-src="assets/images/chat_no_img.gif">
                                </user-info>
                            </dd>
                            <dd class="roomInfo">
                                <div class="chat_nick">
                                    <span class="ico_lv"><img [src]="'assets/images/common/lv/' + list.creater.mb_lv + '.png'" alt="" class="lvS1"></span>
                                    <span class="nick">{{list.creater.mb_nick}}</span>
                                    <span [innerHTML]="list.history"></span>
                                </div>
                                <div class="info">
                                    <span class="time">{{list.created | transferSnsTime}}</span>
                                    <span class="rank">{{list.allowlevelStr}}</span>
                                    <span class="point"><img src="assets/images/common/top_ico_point.png" alt="">{{list.allowpointStr}}</span>
                                    <span class="user_cnt"><em>{{list.joincount}}</em>&#47;{{list.allowmember}}</span>
                                </div>
                            </dd>
                            <span [innerHTML]="list.openTypeHtml"></span>
                        </dl>
                    </li>
                </ul>
            </div>
            <div class="chat-input chat-input_v1">
                <div class="inr" data-[ngStyle]="(!filterActive)? {'margin-left': 0} : {'margin-left': '-100%'}">
                    <div class="layout-row layout-align-space-between-center default">
                        <p class="chat_count"><mat-icon class="mat-default-them mat-icon-12" svgIcon="room" aria-label="개설된 채팅방">개설된 채팅방</mat-icon>개설된 채팅방 <em>{{roomCnt|number}}</em>개</p>
                        <div class="btn_area">
                            <button type="button" class="btn" (click)="btnFilterOpt()">필터</button>
                            <button type="button" class="btn" (click)="openPopoverChatRoom()">채팅방 개설</button>
                        </div>
                    </div>
                    <div class="layout-row layout-align-space-between-center func">
                        <div class="group">
                            <select title="참여 포인트 선택" [(ngModel)]="setData.filterFree" (change)="filterFree()">
                                <option value="">전체</option>
                                <option value="pay">유료</option>
                                <option value="free">무료</option>
                            </select>
                            <select title="게임타입 선택" (change)="filterGameType()" [(ngModel)]="setData.filterGameType">
                                <option value="">전체</option>
                                <!--<option value="g">일반</option>-->
                                <option value="powerLadder">파워사다리</option>
                                <option value="powerball">파워볼</option>
                            </select>
                            <select title="방정렬 선택" (change)="sorting()" [(ngModel)]="setData.sorting">
                                <option value="popular">인기순</option>
                                <option value="users">참여자순</option>
                                <option value="create">최신순</option>
                            </select>
                        </div>
                        <a (click)="btnFilterOpt()" class="clse"><mat-icon class="mat-icon-30 btn_close" svgIcon="xi-close"></mat-icon></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- // chat_box -->
    `
})


export class ChatRoomListComponent implements OnDestroy, OnInit {
    // showNum = 0;
    private ngUnsubscribe = new Subject();
    dynamicHeight = 300;

    roomCnt = 0;
    setData = {filterFree: '', filterGameType: '', sorting: 'popular'};

    // filterFree : 무료/유료 free, pay, filterGameType    : g, 사다리, 다리다리... , sorting : 'popular'; // users, create

    filterActive = false;
    gametypeObj = {
        all: '일반',
        powerball: '파워볼',
        powerLadder: '파워사다리',
        // dari: '다리다리',
        // ladder: '사다리'
    };
    allowlevelObj = {0: '전체', 2: '이등병이상', 6: '하사이상', 10: '소위이상', 13: '소령이상', 16: '준장이상'};
    private rooms: any; // node에서 바로 받은 룸 리스트
    private rawListObj: any; // sorting이 끝난 list
    roomList = []; // rawListObj를 가공하여 넣어둔 데이타

    private roomId: string;
    // private gameType: string;

    @Input() set resizeObject(resizeData: {edges: any, rectangle: any }) {
        if (!resizeData.rectangle) {
            return;
        }
        const  rectangleHeight = resizeData.rectangle.height - 78;
        this.dynamicHeight = rectangleHeight;
    }

    @Input() set selectedChatIndex(index: number) {
        if (index === 3) {
            this.socketService.Emit('leave_curent_room', '@basic1');
            this.socketService.removeListener('publicChat'); // 공개채팅방과 연결된 리스너 삭제
            this.socketService.removeListener('chanceTalkView'); // 찬스톡 상세보기 관련 리스너 삭제

            this.init();
        }
    }

    constructor(
        private socketService: SocketService,
        private eventService: EventService) { // private injector: Injector
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private init() {
        this.socketService.Emit('add_page', {page: this.roomId});
        this.socketService.Emit('show_room_list');

        // 채팅방 목록 가져오기
        this.socketService.On('roomList')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(obj => {
            this.rooms = obj[0];
            this.roomCnt = this.rooms.length;
            this.orderBy();
        });
/*
        this.socketService.sockConnection.chatRoom.push(
            this.socketService.On('roomList')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(obj => {
                this.rooms = obj[0]
                this.roomCnt = this.rooms.length;
                this.orderBy();
            })
        );
*/
    }

    btnFilterOpt() {
        this.filterActive = !this.filterActive;
    }

    /**
     * 개설된 방 리스트를 보여준다.
     */
    private showRoomList() {
        const req =  this.rawListObj;
        const tmpRoomList = [];
        for ( const v of req) {
            if (typeof (v) === 'undefined') {
                return true;
            }

            const obj = JSON.parse(v);

            switch (this.setData.filterFree) {
                case 'free':
                    if (obj.allowpoint !== '0' && obj.allowpoint !== '') {
                        continue;
                    }
                    break;
                case 'pay':
                    if (obj.allowpoint === '0') {
                        continue;
                    }
                    break;
            }
            switch (this.setData.filterGameType) {
                case 'g': if (obj.gametype !== '') { continue; } break;
                case 'powerLadder': if (obj.gametype !== 'powerLadder') { continue; } break;
                case 'powerball': if (obj.gametype !== 'powerball') { continue; } break;
                case 'dari': if (obj.gametype !== 'dari') { continue; } break;
                case 'ladder': if (obj.gametype !== 'ladder') { continue; } break;
            }

            switch (obj.openType) {
                case 'O':
                    obj.openTypeStr = '공개';
                    obj.openTypeHtml = '<dd class="label label_public">공개</dd>';
                    break;
                case 'N':
                    obj.openTypeStr = '비공개';
                    obj.openTypeHtml = '<dd class="label label_private">비공개</dd>';
                    break;
                case 'F':
                    obj.openTypeStr = '친구만';
                    obj.openTypeHtml = '<dd class="label label_friend">친구</dd>';
                    break;
            }

            // 유/무로 체크
            if (obj.allowpoint === '0') {
                obj.allowpointStr = '무료';
            } else {
                obj.allowpointStr = obj.allowpoint;
            }

            // 채팅 타입
            if (obj.gametype === '') {
                obj.gametypeStr = 'all';
            } else {
                obj.gametypeStr = obj.gametype;
            }
            obj.gametypetxt = this.gametypeObj[obj.gametypeStr];

            // 전적
            obj.history    = '';
            if (typeof (obj.info) !== 'undefined' && obj.info !== false) {
                obj.history = '(';
                obj.history += obj.info.win + '승 ' + obj.info.lose + '패 ';
                if (obj.info.series_win !== '0') {
                    obj.history += '<span class="txt_pick_win">' + obj.info.series_win + '연승중</span>';
                } else if (obj.info.series_lose !== '0') {
                    obj.history += '<span class="txt_pick_lose">' +  obj.info.series_lose + '연패중</span>';
                }
                obj.history += ')';
            }

            // 참여등급
            if (obj.allowlevel === '') { obj.allowlevel = '0'; }
            obj.allowlevelStr = this.allowlevelObj[obj.allowlevel];

            tmpRoomList.push(obj);
        } // $.each(req, function(i, v) { // 과거 저장된 내용을 디스플레이 한다.

        this.roomList = tmpRoomList;
    }

    // 채팅방 개설하기
    openPopoverChatRoom() {
        const obj = {type: 'popup', component: 'chatroom-create'};
        this.eventService.broadcast('popup', obj);
    }

    // 채팅 룸 진입
    goto_chatRoom_view(roomid: string) {
        // 채팅룸 진입
    //    this.$emit('chatRoomView', roomid);
        const obj = { type: 'chatroomView', room_id: roomid};
        this.eventService.broadcast('chancetalk', obj);
    }

    // 필터 및 sorting
    // 유/무료 디스픞레이
    filterFree() {
        this.showRoomList();
    }

    filterGameType() {
        /*
        switch (this.setData.filterGameType) {
            case 'g':
                this.gameType = 'normal';
                break;
            case 'powerLadder':
                this.gameType = 'power_ladder';
                break;
            case 'powerball':
                this.gameType = 'powerball';
                break;
            case 'dari':
                this.gameType = 'dari';
                break;
            case 'ladder':
                this.gameType = 'ladder';
                break;
            default:
                this.gameType = 'all';
                break;
        }
        */

        this.showRoomList();
    }

    private sortObject() {
        const sortable = [];
        for ( const room of this.rooms) {
            const tmp = JSON.parse(room);
            switch (this.setData.sorting) {
                case 'popular': sortable.push([room, tmp.rank_recommend_current]); break;
                case 'users': sortable.push([room, tmp.rank_join_current]); break;
                case 'create': sortable.push([room, tmp.created]); break;
            } // this.setData.sorting = 'popular'; // users, create
        }

        sortable.sort((a, b) => {
            return b[1] - a[1];
            // return a[1] - b[1];
        });

        const rtn = [];
        for (const i  in sortable) {
            if (sortable.hasOwnProperty(i)) {
                rtn.push(sortable[i][0]);
            }
        }
        return rtn;
    }

    private sortObjectAsc() {
        const sortable = [];
        for ( const room of this.rooms) {
            const tmp = JSON.parse(room);
            switch (this.setData.sorting) {
                case 'popular': sortable.push([room, tmp.rank_recommend_current]); break; // 많음이 좋음
                case 'users': sortable.push([room, tmp.rank_join_current]); break; // 적음이 좋음
                case 'create': sortable.push([room, tmp.created]); break;
            } // this.setData.sorting = 'popular'; // users, create
        }

        sortable.sort((a, b) => {
            return a[1] - b[1];
        });

        const rtn = [];
        for ( const j  in sortable) {
            if (sortable.hasOwnProperty(j)) {
                rtn.push(sortable[j][0]);
            }
        }
        return rtn;
    }


    sorting() {
        this.orderBy();
    }

    private orderBy() {
        let obj: any;
        switch (this.setData.sorting) {
            case 'popular': obj = this.sortObjectAsc(); break;
            case 'users': obj = this.sortObjectAsc(); break;
            case 'create': obj = this.sortObject(); break;
        } // this.setData.sorting = 'popular'; // users, create
        this.rawListObj = obj;
        this.showRoomList();
    }
}

@NgModule({
    declarations: [
        ChatRoomListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatIconModule,
        UserInfoModule,
        TransferSnsTimePipeModule,
        SharedPipeChatModule
    ],
    exports: [
        ChatRoomListComponent
    ]
})

export class ChatRoomListModule {}
